<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>在线客服设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox">
        <div class="btns">
            <div @click="btnsTz">
              <img src="@/assets/adds.png" alt="">
              添加词条</div>
            </div>
        <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
      >
        <!-- <el-table-column prop="id" label="序号" ></el-table-column> -->
      
      <el-table-column type="index" label="序号" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.sort" @input="changeInput(scope.row)"></el-input>
        </template>
      </el-table-column>
        <el-table-column prop="title" label="标题" >
          <template slot-scope="scope">
              <span style="
                      display: -webkit-box;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      -webkit-line-clamp:1;
                      -webkit-box-orient: vertical;
                      white-space: pre-line;
                      text-align:left;
                  ">
                {{scope.row.title}}
              </span>
          </template>
        </el-table-column>
        <el-table-column prop="keywords" label="关键字">
          <template slot-scope="scope">
              <span style="
                      display: -webkit-box;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      -webkit-line-clamp:1;
                      -webkit-box-orient: vertical;
                      white-space: pre-line;
                      text-align:left;
                  ">
                {{scope.row.keywords}}
              </span>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="回答"  width="450">
          <template slot-scope="scope">
            <span class="conten_span" style="
                      display: -webkit-box;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      -webkit-line-clamp:1;
                      -webkit-box-orient: vertical;
                      white-space: pre-line;
                      text-align:left;
                  "
                 v-html="scope.row.content" >
                
              </span>
          </template>
        </el-table-column>
        <el-table-column  label="是否有触发词">
            <template slot-scope="scope">
              {{scope.row.keywords_flag=='1'?'否':'是'}}
            </template>
        </el-table-column>
        <el-table-column prop="createtime" label="发布时间" width="160"></el-table-column>
        <el-table-column  label="发布状态">
            <template slot-scope="scope">
              {{scope.row.state=='1'?'已发布':'未发布'}}
            </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="200">
            <template slot-scope="scope">
              <div style="display:flex;">
                <div class="detail_btns" @click="openDetail(scope.row)">详情</div>
                <div class="detele" @click="deteleClick(scope.row)">删除</div>
                <div class="tow_btns" @click="zantingClick(scope.row)">{{scope.row.state=='1'?'暂停发布':'发布'}}</div>
              </div>
            </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="total" :current-page="data.page"  @current-change="pagination"></el-pagination>
      </div>
    </el-card>
    <el-dialog :close-on-click-modal="false"
      title="添加词条"
      :visible.sync="flow"
      :before-close="Close"
      width="36%"
      center
    >
      <el-divider></el-divider>
      <div class="form_tz">
        <el-form :model="ruleForm"  ref="ruleForm" label-width="130px" class="demo-ruleForm">
            <el-form-item label="文字题目：" prop="title" >
              <el-input v-model="ruleForm.title"></el-input>
            </el-form-item>
            <el-form-item label="关键字：" prop="title">
              <el-input v-model="ruleForm.keywords" placeholder="使用、分割不同的关键词"></el-input>
            </el-form-item>
            <el-form-item label="答案内容：" prop="title" >
              <!-- <el-input type="textarea" :autosize="{ minRows: 8, maxRows: 8}" v-model="ruleForm.content"></el-input> -->
              <quill-editor 
                  v-model="ruleForm.content" 
                  ref="myQuillEditor" 
                  :options="editorOption"
                >
                </quill-editor>
            </el-form-item>

            <el-form-item label="是否添加触发词：" prop="title">
                <el-switch
                  v-model="value"
                  active-color="#246DEB"
                  inactive-color="#E5E5EA">
                </el-switch>
            </el-form-item>
            <el-form-item label="文字题目："  prop="title" v-if="value">
                <div class="title_txt">
                  <el-select clearable   filterable   v-model="itm.id" v-for="(itm,index) in arrPtion" :key="index" >
                    <el-option
                      v-for="item in tableData"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
            </el-form-item>
            <div class="add_form" v-if="value" @click="addOpen">
              <img src="@/images/formadd.png" alt="">
            </div>
            <el-form-item label="发布：" prop="title">
              <el-radio v-model="ruleForm.state" label="1">及时发布</el-radio>
              <el-radio v-model="ruleForm.state" label="2">暂不发布</el-radio>
            </el-form-item>
        </el-form>
        <div class="form_btn">
          <div @click="Close">取消</div>
          <div @click="btns">完成</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addServiceContent , getServiceList , changeState , changeServiceSort } from "@/request/set.js";
import { MessageBox,Message} from 'element-ui'
import {quillRedefine} from 'vue-quill-editor-upload'
export default {
  data(){
    return{
      value:false,
      flow:false,
      ruleForm:{
        token:window.sessionStorage.getItem("Token"),
        keywords:'',
        content:'',
        keywords_flag:'',
        state:'1',
        title:'',
        cs_id:''
        // title:'',
        // content:'',
        // ids:'',
        // radio:'1',
        // time:''
      },
      tableData:[],
      total:0,
      data:{
        token:window.sessionStorage.getItem("Token"),
        page:1,
        page_size:10,
        title:'',
        keywords:'',
        cs_id:'',
        pageIndexCopy:1
      },
      arrPtion:[
        {
          id:''
        }
      ],
      editorOption:{}
    }
  },
  created(){
    this.getList()
    this.editorOption = quillRedefine(
        {
          // 图片上传的设置
          uploadConfig: {
            action: 'http://xwt.softykt.net/api/jfy/uploadVideoImg',  // 必填参数 图片上传地址
            token:window.sessionStorage.getItem("Token"),
            name: 'file', 
            methods: 'POST', 
            // 必选参数  res是一个函数，函数接收的response为上传成功时服务器返回的数据
            // 你必须把返回的数据中所包含的图片地址 return 回去
            res: (respnse) => {
              return respnse.result
            },
          }
        }
      )
  },
  methods:{
    changeInput(item){
      let data = {
        serviceid:item.id,
        token:window.sessionStorage.getItem("Token"),
        sort:item.sort
      }
      changeServiceSort(data).then(res=>{
        if(res.data.status=='ok'){
          this.$message.success('修改排序成功')
          this.getList()
        }
      })
    },
    openDetail(item){
      this.flow = true
      if(item.keywords_flag == 2){
        this.value = true
      }else{
        this.value = false
      }
      this.ruleForm={
        token:window.sessionStorage.getItem("Token"),
        keywords:item.keywords,
        content:item.content,
        state:item.state + '',
        title:item.title,
        cs_id:item.cs_id,
        id:item.id
      }
      if(item.cs_id){
        this.arrPtion = []
        item.cs_id.split(',').map(items=>{
          this.arrPtion.push({
            id:  Number(items)
          })
        })
      }
    },
    hIndex(index){
      return (this.data.pageIndexCopy- 1) * this.data.page_size + index + 1
    },
    zantingClick(row){
      MessageBox('此操作将修改状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            token:window.sessionStorage.getItem("Token"),
            id:row.id,
            state:row.state=='1'?'2':'1'
          }
          changeState(data).then(res=>{
            if(res.data.rcode==200){
              this.data.page = 1
              this.getList()
              Message.success('操作成功')
            }else{
              Message.error(res.data.msg)
            }
          })
        }).catch(() => {
                 
       });
    },
    addOpen(){
      this.arrPtion.push({
        id:''
      })
    },
    pagination(e){
      this.data.page = e
      this.data.pageIndexCopy = e
      this.getList()
    },
    deteleClick(row){
      MessageBox('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            token:window.sessionStorage.getItem("Token"),
            id:row.id,
            state:3
          }
          changeState(data).then(res=>{
            if(res.data.rcode==200){
              this.data.page = 1
              this.getList()
              Message.success('删除成功')
            }
          })
        }).catch(() => {
                 
       });
    },
    getList(){
      getServiceList(this.data).then(res=>{
        if(res.data.rcode=='200'){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },  
    btnsTz(){
      this.value = false
      this.flow = true
    },
    Close(){
      this.flow = false
      this.ruleForm={
        token:window.sessionStorage.getItem("Token"),
        keywords:'',
        content:'',
        keywords_flag:'',
        state:'1',
        title:'',
        cs_id:''
      }
      this. arrPtion = [
        {
          id:''
        }
      ]
    },
    btns(){
      if(this.ruleForm.title==''){
        Message.error('请输入标题')
        return false
      }
      if(this.ruleForm.keywords==''){
        Message.error('请输入关键词')
        return false
      }
      if(this.ruleForm.content==''){
        Message.error('请输入答案内容')
        return false
      }
      let ids = ''
      this.arrPtion.map(item=>{
        ids += item.id + ','
      })
      this.ruleForm.cs_id = ids.slice(0,-1)
      if(this.value){
        this.ruleForm.keywords_flag = 2
      }else{
        this.ruleForm.keywords_flag = 1
      }
      addServiceContent(this.ruleForm).then(res=>{
        if(res.data.rcode==200){
          this.flow = false
          this.data.page = 1
          this.getList()
          Message.success('添加成功')
          this.ruleForm={
            token:window.sessionStorage.getItem("Token"),
            keywords:'',
            content:'',
            keywords_flag:'',
            state:'1',
            title:'',
            cs_id:''
          }
          this. arrPtion = [
            {
              id:''
            }
          ]
        }else{
          Message.error(res.data.msg)
        }
      })
    },
      // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .el-textarea__inner{
    resize: none;
}
.conentBox{
  margin-top: 2rem;
  padding: 2rem;
  .btns{
    display: flex;
    justify-content: flex-end;
    margin-bottom: 2rem;
    div{
      cursor: pointer;
      width: 13.2rem;
      height: 3.8rem;
      border: 2px solid #246DEB;
      font-size: 1.4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #246DEB;
      border-radius: 0.4rem;
      font-weight: 500;
      img{
        width: 1.4rem;
        height: 1.4rem;
        margin-right: 1rem;
      }
    }
  }
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  position: relative;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
.detele{
  color: #FF4D4F;
  font-size: 1.4rem;
  cursor: pointer;
}
.two_btns{
  color: #246DEB;
  font-size: 1.4rem;
  margin-left: 2rem;
  cursor: pointer;
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
.form_tz{
  ::v-deep .el-select{
    width: 100%;
  }
}
.form_btn{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5rem;
  margin-bottom: 2rem;
  >div{
    width: 10rem;
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.4rem;
    cursor: pointer;
    border-radius: 0.4rem;
    &:nth-child(1){
      border: 1px solid #246DEB;
      color: #246DEB;
    }
    &:nth-child(2){
      background: #246DEB;
      color: #FFFFFF;
      margin-left: 2rem;
    }
  }
}
.add_form{
  margin-left: 13rem;
  img{
    width: 4rem;
    height: 4rem;
    cursor: pointer;
  }
}
.tow_btns{
  color: #246DEB;
  margin-left: 2rem;
  cursor: pointer;
}
.title_txt{
  ::v-deep .el-select{
    margin-bottom: 2rem;
    &:last-child{
      margin-bottom: 0;
    }
  }
}
::v-deep th {
  .cell{
    &:last-child{
      text-align: left !important;
    }
  }
}
 ::v-deep .cell{
  text-align: left;
}
.detail_btns{
  color: #246DEB;
  margin-right: 2rem;
  cursor: pointer;
}
.conten_span{
  ::v-deep p{
    margin: 0 !important;
  }
  ::v-deep img{
    display: none;
  }
}
</style>